module.exports = __webpack_public_path__ + "media/images/category/dummy/bag04-9608e4bffa5fa254584b277a8b674b6d.jpg";